import React from 'react';
 
function Container({children}) {
   return <div className="containerArea">{children}</div>
}
 
export default Container;